/**
 * Options for token storage
 */
interface StorageOptions {
  secure?: boolean // Indicates that token requires more secure storage
}

/**
 * Utility for secure token storage
 * Abstracts storage mechanism (localStorage, sessionStorage)
 */
class TokenStorage {
  /**
   * Sets value in storage
   */
  setItem(key: string, value: string, options: StorageOptions = {}): void {
    if (options.secure) {
      sessionStorage.setItem(key, value)
    } else {
      // For regular tokens use localStorage
      localStorage.setItem(key, value)
    }
  }

  /**
   * Gets value from storage
   */
  getItem(key: string): string | null {
    // Check both storages
    return sessionStorage.getItem(key) ?? localStorage.getItem(key)
  }

  /**
   * Removes value from storage
   */
  removeItem(key: string): void {
    // Remove from both storages
    sessionStorage.removeItem(key)
    localStorage.removeItem(key)
  }

  /**
   * Clears all storage
   */
  clear(): void {
    sessionStorage.clear()
    localStorage.clear()
  }
}

export const tokenStorage = new TokenStorage()
